"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const mongoose_1 = tslib_1.__importDefault(require("mongoose"));
const v4_1 = tslib_1.__importDefault(require("uuid/v4"));
const lieuucationTimestampedSchema = new mongoose_1.default.Schema({
    internalId: { type: String, required: true, index: true },
    date: { type: Date, required: true }
});
const locationTimestampedSchema = new mongoose_1.default.Schema({
    lat: { type: Number, required: true, index: true },
    lon: { type: Number, required: true, index: true },
    date: { type: Date, required: false, default: Date.now }
});
const userSchema = new mongoose_1.default.Schema({
    verified: { type: Boolean, default: false },
    verifyKey: { type: String, default: v4_1.default, index: true },
    resetKey: { type: String },
    resetKeyDate: { type: Date },
    avatar: { type: String },
    email: {
        type: String,
        index: true,
        unique: true,
        lowercase: true,
        required: true
    },
    name: { type: String, required: true },
    userType: { type: String, index: true, required: true },
    password: { type: String, required: true },
    viewedLieuucations: [lieuucationTimestampedSchema],
    favoritedLieuucations: [lieuucationTimestampedSchema],
    isOnMarketingList: { type: Boolean, default: false },
    ipList: [{ type: String }],
    userAgents: [{ type: String }],
    coordinates: [locationTimestampedSchema]
}, {
    timestamps: true
});
const v1UserModel = mongoose_1.default.model('User', userSchema);
exports.v1UserModel = v1UserModel;
//# sourceMappingURL=User.model.js.map